import { render, staticRenderFns } from "./BackhaulAction.vue?vue&type=template&id=24ec4e27"
import script from "./BackhaulAction.vue?vue&type=script&lang=js"
export * from "./BackhaulAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports